import React from 'react';
import { SEOHead, LocalBusinessSchema } from '../components/SEOHead';
import { WebSiteSchema } from '../components/SEOHead';
import Hero from '../components/Hero';
import LiveStatusPanel from '../components/LiveStatusPanel';
import ScenarioServices from '../components/ScenarioServices';
import SocialProof from '../components/SocialProof';
import HowItWorks from '../components/HowItWorks';
import Stats from '../components/Stats';
import Services from '../components/Services';
import About from '../components/About';
import Brands from '../components/Brands';
import BlogPreview from '../components/BlogPreview';
import CTAStrip from '../components/CTAStrip';
import ContactSection from '../components/ContactSection';
import DistrictLinks from '../components/DistrictLinks';
import SEOContent from '../components/SEOContent';

import HomepageFAQ from '../components/HomepageFAQ';
import ReviewsSection from '../components/ReviewsSection';

/*
 * Homepage V3.2
 * Added FAQ section, SEO Content, District Links
 */
export default function Home() {
  return (
    <main>
      <SEOHead path="/" />
      <LocalBusinessSchema />
      <WebSiteSchema />
      <Hero />
      <LiveStatusPanel />
      <About />
      <ScenarioServices />
      <Stats />
      <SocialProof />
      <HowItWorks />
      <Services />
      <Brands />
      <DistrictLinks />
      <SEOContent />
      <HomepageFAQ />
      <ReviewsSection />
      <BlogPreview />
      <CTAStrip />
      <ContactSection />
    </main>
  );
}
